import styled from "@emotion/styled";
import { Table } from "antd";
import { genericStyles } from "../../../constant";

export const StyledBranchModalDiv = styled.div`
  .section-title {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 16px;
  }

  .day-header {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .day-name {
    min-width: 80px;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
  }

  .time-slot-container {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .time-separator {
    flex-shrink: 0;
  }

  .time-picker {
    width: 100%;
    min-width: 120px;
    max-width: 140px;
  }

  .schedule-scroll {
    height: 250px;
    overflow-y: auto;
  }

  .day-section {
    margin-bottom: 16px;
  }

  .add-slot-btn {
    margin-top: 8px;
  }

  .form-actions {
    margin-bottom: 0;
    margin-top: 30px;
  }

  .actions-space {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  .operating-hours-header {
    margin-bottom: 8px;
  }
`;

export const StyledTable = styled(Table)`
  .branch-details-cell {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .branch-name {
    font-size: 16px;
    font-weight: 500;
    color: #111827;
    margin-bottom: 4px;
  }

  .branch-email {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #6b7280;
  }

  .branch-code {
    display: inline-block;
    padding: 2px 8px;
    background: #f3f4f6;
    border-radius: 4px;
    font-size: 11px;
    color: #6b7280;
    font-family: monospace;
    margin-top: 4px;
    width: fit-content;
  }

  .location-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .location-address {
    font-size: 14px;
    color: #111827;
    font-weight: 500;
  }

  .location-city {
    font-size: 13px;
    color: #6b7280;
  }

  .location-timezone {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
  }

  .timezone-badge {
    padding: 2px 8px;
    background: #dbeafe;
    border-radius: 4px;
    font-size: 11px;
    color: ${genericStyles.primaryColor};
    font-weight: 500;
  }

  .timezone-hours {
    font-size: 12px;
    color: #6b7280;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .manager-cell {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .manager-avatar {
    background: ${genericStyles.primaryColor};
    color: #ffffff;
    font-weight: 500;
    flex-shrink: 0;
  }

  .manager-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .manager-name {
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .manager-role {
    font-size: 12px;
    color: #6b7280;
  }

  .status-active {
    background: rgba(16, 185, 129, 0.1);
    color: #059669;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .status-inactive {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .actions-cell {
    display: flex;
    gap: 8px;
  }

  .btn-edit {
    background: rgba(236, 72, 153, 0.1);
    border: 1px solid rgba(236, 72, 153, 0.3);
    color: #ec4899;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 16px;
    height: auto;
    font-weight: 500;
  }

  .btn-edit:hover {
    background: rgba(236, 72, 153, 0.15);
    border-color: rgba(236, 72, 153, 0.5);
    color: #ec4899;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
  }

  .status-dot-active {
    background: #10b981;
  }

  .status-dot-inactive {
    background: #ef4444;
  }
`;
